import classnames from 'classnames/bind'
import React from 'react'

import { ImageProps } from '~/components/Abstracts/Image'
import Image from '~/components/UI/Image'

import { EditoSliceProps } from '~/data/slices-data'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type HeroSimpleImageProps = EditoSliceProps & {
  className?: string
  image: ImageProps
}

const IMAGE_SIZES = [{ ratio: 1 }]

function HeroSimpleImage({
  className,
  image,
  aboveTheFold,
}: HeroSimpleImageProps) {
  return (
    <div className={cx(css.HeroSimpleImage, className)}>
      <Image
        layout="fill"
        objectFit="cover"
        objectPosition="center center"
        sizesFromBreakpoints={IMAGE_SIZES}
        className={css.image}
        priority={aboveTheFold}
        {...image}
      />
    </div>
  )
}

HeroSimpleImage.defaultProps = {}

export default HeroSimpleImage
